module.exports = __webpack_public_path__ + "rfm-avatar-champion.svg?873338201aeadc25dd885807d910795e";